<div [ngClass]="{ 'n-header-fixed': true, 'n-header-hidden': isHeaderHidden }">
  <div class="relative">
    <div class="n-container n-header-inner">
      <!-- Esquerda: hamburger (mobile) + logo -->
      <div class="n-header-left">
        @if(featureSHeader.anchors){
        <button
          class="n-mobile-menu-btn"
          (click)="toggleMobileMenu()"
          [attr.aria-label]="'GLOBAL.ABRIR_MENU' | translate"
        >
          <i class="pi pi-bars"></i>
        </button>
        }
        <p-avatar
          image="{{ featureSHeader.logo }}"
          shape="circle"
          size="large"
          class="n-logo-clickable"
          (click)="navegarHome()"
        >
        </p-avatar>
        <lib-feature-s-pwa-online-status></lib-feature-s-pwa-online-status>
      </div>

      <!-- Centro: nav links (desktop) -->
      @if(featureSHeader.anchors){
      <nav class="n-header-nav">
        @for(anchor of featureSHeader.anchors; track anchor.label){
        @if(anchor.route){
        <a
          [routerLink]="anchor.route"
          [fragment]="anchor.fragment"
          class="n-header-nav-link"
        >
          {{ anchor.label }}
        </a>
        } @else {
        <a [href]="anchor.href" class="n-header-nav-link">
          {{ anchor.label }}
        </a>
        } }
      </nav>
      }

      <!-- Direita: ações -->
      <div class="n-header-right">
        <div
          class="flex align-items-center justify-content-center n-pointer"
          (click)="language.toggle()"
          [title]="'GLOBAL.SELECIONAR_IDIOMA' | translate"
          [attr.aria-label]="'GLOBAL.SELECIONAR_IDIOMA' | translate"
        >
          <i class="pi pi-language"></i>
        </div>
        <lib-n-popover #language>
          <lib-language-selector
            (languageSelected)="language.close()"
          ></lib-language-selector>
        </lib-n-popover>
        @if($usuarioLogado()?.id){
        <div class="flex items-center gap-2 n-card-mini">
          @if (helpVisible) {
          <div
            class="flex align-items-center justify-content-center n-pointer p-1"
            (click)="helpCenterService.openHelp()"
            [title]="'GLOBAL.CENTRAL_AJUDA' | translate"
            [attr.aria-label]="'GLOBAL.ABRIR_CENTRAL_AJUDA' | translate"
            role="button"
            tabindex="0"
            (keyup.enter)="helpCenterService.openHelp()"
          >
            <i class="pi pi-question-circle text-lg" style="color: #38bdf8"></i>
          </div>
          }

          <div
            class="flex align-items-center justify-content-center n-pointer"
            (click)="listaAgendamento.toggle()"
          >
            @if(featureSHeader.badgeIsVisible){ @if (hasBadge()) {
            <p-overlaybadge
              [value]="badgeCount()"
              styleClass="n-calendar-badge"
              badgeSize="small"
            >
              <i class="pi pi-calendar"></i>
            </p-overlaybadge>
            } @else {
            <i class="pi pi-calendar"></i>
            } }
          </div>
          <lib-n-popover #listaAgendamento>
            <ng-container #calendarPopoverContainer></ng-container>
            @if (!calendarPopoverAvailable()) {
            <div class="p-3 text-center text-sm text-500">
              {{ 'GLOBAL.NENHUMA_NOTIFICACAO' | translate }}
            </div>
            }
          </lib-n-popover>
          <div class="container-do-gatilho" data-tour="header-perfil">
            <p-avatar
              [image]="$avatarImagemUrl() ?? undefined"
              [icon]="$avatarImagemUrl() ? undefined : 'pi pi-user'"
              [styleClass]="
                $avatarImagemUrl()
                  ? 'n-pointer'
                  : 'n-pointer n-header-user-avatar-fallback'
              "
              shape="circle"
              (click)="meuPopover.toggle()"
            />
            <lib-n-popover #meuPopover>
              <div class="flex flex-column gap-4">
                <div class="n-card-mini">
                  <div class="flex align-items-center gap-1">
                    <p-avatar
                      [image]="$avatarImagemUrl() ?? undefined"
                      [icon]="$avatarImagemUrl() ? undefined : 'pi pi-user'"
                      shape="circle"
                      size="large"
                      [styleClass]="
                        $avatarImagemUrl()
                          ? ''
                          : 'n-header-user-avatar-fallback'
                      "
                    />
                    <div class="flex flex-column gap-1">
                      <span>{{ $usuarioLogado()?.nome }}</span>
                      @if ($perfilLabel()) {
                      <p-tag
                        styleClass="n-header-user-perfil"
                        [value]="$perfilLabel()! | translate"
                        severity="info"
                      ></p-tag>
                      }
                    </div>
                  </div>
                </div>
                <div class="flex flex-column justify-center gap-1">
                  <p-button
                    icon="pi pi-user"
                    severity="info"
                    variant="outlined"
                    [label]="'GLOBAL.MINHA_CONTA' | translate"
                    [styleClass]="'w-full'"
                    (click)="meuPopover.close(); editarPerfil()"
                  ></p-button>
                </div>
                @if (tourReplayAvailable) {
                <div class="flex flex-column justify-center gap-1">
                  <p-button
                    icon="pi pi-compass"
                    severity="secondary"
                    variant="outlined"
                    [label]="tourReplayKey() | translate"
                    [styleClass]="'w-full'"
                    (click)="meuPopover.close(); replayTour()"
                  ></p-button>
                </div>
                }
                @if (helpVisible) {
                <div class="flex flex-column justify-center gap-1">
                  <p-button
                    icon="pi pi-question-circle"
                    severity="secondary"
                    variant="outlined"
                    [label]="'GLOBAL.CENTRAL_AJUDA' | translate"
                    [styleClass]="'w-full'"
                    (click)="meuPopover.close(); helpCenterService.openHelp()"
                  ></p-button>
                </div>
                }
                <div class="flex flex-column justify-center gap-1">
                  <p-button
                    icon="pi pi-sign-out"
                    severity="danger"
                    variant="outlined"
                    [label]="'GLOBAL.SAIR' | translate"
                    [styleClass]="'w-full'"
                    (click)="meuPopover.close(); logout()"
                  ></p-button>
                </div>
              </div>
            </lib-n-popover>
          </div>
          <div
            class="flex align-items-center justify-content-center n-pointer"
            (click)="toggleTheme()"
          >
            <i class="pi pi-{{ $iconTheme() }}"></i>
          </div>
        </div>
        }@else{
        <div class="n-header-cta">
          @if(featureSHeader.signup){
          <button class="n-cta-signup-link" (click)="onSignup.emit()">
            {{ featureSHeader.signup.label }}
          </button>
          }
          <button class="n-cta-nav n-cta-login" (click)="irParaLogin()">
            {{ 'GLOBAL.ENTRAR' | translate }}
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</div>

@if(featureSHeader.anchors){
<div
  class="n-mobile-drawer-overlay"
  [class.n-mobile-drawer-overlay--open]="isMobileMenuOpen()"
  (click)="closeMobileMenu()"
></div>
<aside
  class="n-mobile-drawer"
  [class.n-mobile-drawer--open]="isMobileMenuOpen()"
>
  <div class="n-mobile-drawer-header">
    <p-avatar
      image="{{ featureSHeader.logo }}"
      shape="circle"
      size="large"
      class="n-logo-clickable"
      (click)="navegarHome()"
    ></p-avatar>
    <button
      class="n-mobile-drawer-close"
      (click)="closeMobileMenu()"
      [attr.aria-label]="'GLOBAL.FECHAR_MENU' | translate"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
  <nav class="n-mobile-drawer-nav">
    @for(anchor of featureSHeader.anchors; track anchor.label){
    @if(anchor.route){
    <a
      [routerLink]="anchor.route"
      [fragment]="anchor.fragment"
      class="n-mobile-drawer-link"
      (click)="closeMobileMenu()"
      >{{ anchor.label }}</a
    >
    } @else {
    <a
      [href]="anchor.href"
      class="n-mobile-drawer-link"
      (click)="closeMobileMenu()"
      >{{ anchor.label }}</a
    >
    } }
  </nav>
</aside>
}
